import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Actions} from '../../../common/actions';
import CardsByOrderType from '../../../accessories/components/kanban/cardsByOrderType';

class Service extends Component {
  componentDidMount() {
    const {chassis} = this.props;
    this.props.fetchOrdersByChassis(chassis, {'hideOrderCancelled': 'yes'});
  }
  
  render() {
    const {loading, orders} = this.props;
    return <CardsByOrderType loading={loading} orders={orders} />;
  }
}

const mapStateToProps = (state) => {
  return {
    'orders': state.vehicleHistory.orders,
    'loading': state.vehicleHistory.loading,
  };
};

const {
  fetchOrdersByChassis,
} = Actions;

export default connect(mapStateToProps, {
  fetchOrdersByChassis,
})(Service);
